(() => {
  const selectors = {
    root: ".collection__products",
    card: ".product-item",
    slider: "product-media-slider",
    swatch: "a.product__color-swatch--sibling-product",
    cardImages: "[data-product-card-dynamic-media] img",
    slideOverlay: ".product-media-slide-overlay",
    titleLink: ".product-item__product-title a",
    imageLink: ".product-item__image-link",
    quickShopTrigger: "[data-product-url]",
    selectedSwatch: ".product__color-swatch.selected",
  };

  const getSwatchImages = (swatch) => {
    try {
      return JSON.parse(swatch.dataset.cardImages || "[]");
    } catch (error) {
      return [];
    }
  };

  const getSwatchSlider = (swatch) => swatch.dataset.cardSlider || "";

  const updateSelectedSwatch = (card, selectedSwatch) => {
    card.querySelectorAll(selectors.selectedSwatch).forEach((swatch) => {
      swatch.classList.remove("selected");
    });

    selectedSwatch.classList.add("selected");
  };

  const updateImage = (image, imageData) => {
    if (!image || !imageData?.src) return;

    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.src = imageData.src;
    image.alt = imageData.alt || "";
  };

  const updateCardImages = (card, swatchImages) => {
    if (!swatchImages.length) return;

    const cardImages = Array.from(card.querySelectorAll(selectors.cardImages));

    cardImages.forEach((image, index) => {
      const imageData = swatchImages[index];

      if (!imageData?.src) return;

      updateImage(image, imageData);
    });
  };

  const getActiveSlideIndex = (slider) => {
    if (!slider) return 0;
    if (typeof slider.currentIndex === "number") return slider.currentIndex;

    const activeSlideIndex = Array.from(slider.querySelectorAll(".product-item__slide")).findIndex((slide) =>
      slide.classList.contains("is-active")
    );

    return activeSlideIndex >= 0 ? activeSlideIndex : 0;
  };

  const updateCardSlider = (card, sliderMarkup) => {
    if (!sliderMarkup) return false;

    const currentSlider = card.querySelector(selectors.slider);
    if (!currentSlider) return false;

    const activeSlideIndex = getActiveSlideIndex(currentSlider);
    currentSlider.outerHTML = sliderMarkup;

    const nextSlider = card.querySelector(selectors.slider);
    const nextSlidesCount = nextSlider?.querySelectorAll(".product-item__slide").length || 0;
    const nextSlideIndex = Math.min(activeSlideIndex, Math.max(nextSlidesCount - 1, 0));

    if (nextSlider && typeof nextSlider.goToSlide === "function" && nextSlideIndex > 0) {
      nextSlider.goToSlide(nextSlideIndex);
    }

    return true;
  };

  const updateCardLinks = (card, href) => {
    const titleLink = card.querySelector(selectors.titleLink);
    const imageLink = card.querySelector(selectors.imageLink);
    const slideOverlays = card.querySelectorAll(selectors.slideOverlay);
    const quickShopTriggers = card.querySelectorAll(selectors.quickShopTrigger);

    if (titleLink) titleLink.href = href;
    if (imageLink) imageLink.href = href;

    slideOverlays.forEach((link) => {
      link.href = href;
    });

    quickShopTriggers.forEach((trigger) => {
      trigger.setAttribute("data-product-url", href);
    });
  };

  const bindSwatchClick = (root) => {
    root.addEventListener("click", (event) => {
      const swatch = event.target.closest(selectors.swatch);

      if (!swatch || !root.contains(swatch)) return;

      const card = swatch.closest(selectors.card);
      if (!card) return;

      const href = swatch.getAttribute("href");
      if (!href) return;

      const swatchImages = getSwatchImages(swatch);
      const swatchSlider = getSwatchSlider(swatch);

      if (!swatchImages.length && !swatchSlider) return;

      event.preventDefault();
      event.stopPropagation();

      updateSelectedSwatch(card, swatch);
      if (!updateCardSlider(card, swatchSlider)) {
        updateCardImages(card, swatchImages);
      }
      updateCardLinks(card, href);
    });
  };

  const init = () => {
    const root = document.querySelector(selectors.root);
    if (!root) return;

    if (root.dataset.plpSwatchImageUpdateInitialized === "true") return;
    root.dataset.plpSwatchImageUpdateInitialized = "true";

    bindSwatchClick(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
